const state = {
    systemMessage: {
        message: '',
        status: false,
        tm: false
    }
}
const getters = {}
const actions = {
    hideMessage ({ commit }) {
        commit('hide_message')
    },
    showMessage ({ commit, state }, data) {
        if (state.systemMessage.tm) commit('hide_message')
        commit('show_message', data)
        state.systemMessage.tm = setTimeout(() => {
            commit('hide_message')
        }, 2000)
    }
}
const mutations = {
    hide_message (state) {
        state.systemMessage.message = ''
        state.systemMessage.status = false
        if (state.systemMessage.tm) clearTimeout(state.systemMessage.tm)
    },
    show_message (state, data) {
        state.systemMessage.message = data.message
        state.systemMessage.status = data.status
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}